<template>
    <div class="vcalendar">
        <Calendar title-position="left"
        :v-model="selectedDate"
        :attributes="calendarEvents"
        @transition-start="transitionStart()"
        @dayclick="dayClick"
        :initial-page="initialPage"
        ref="calendar"/>
    </div>
</template>
<script>

import { Calendar } from 'v-calendar';
import 'v-calendar/style.css';
export default {
    name: 'VCalendar',
    components: {
        Calendar
    },
    props: [
        'events',
        'selectedDate',
        'parentClass',
    ],
    data(){
        let colors = ['red', 'blue', 'green', 'yellow']
        return {
            colors: colors
        }
    },
    computed: {
        eventColors(){
            let _eventColors = {}
            let color_index = 0
            for (let event of this.events) {
                if(!Object.keys(_eventColors).find((key)=>key==event.eventName)){
                    _eventColors[event.eventName] = this.colors[color_index]
                    if (color_index == color_index.length -1){
                        color_index = 0
                    }
                    else
                        color_index += 1
                }
            }
            return _eventColors
        },
        calendarEvents(){
            function getDatesBetween(start, end) {
                let dates = [new Date(start)];
                let currentDate = new Date(start);
                while (currentDate < end) {
                    let newDate = new Date(currentDate);
                    newDate.setDate(currentDate.getDate() + 1)
                    currentDate.setDate(currentDate.getDate() + 1);
                    dates.push(newDate);
                }
                return dates;
            }

            let _events = []
            let eventNamesDescription =[]
            let added_event = false
            let chosen_color = ''
            for (let event of this.events){
                added_event = false
                for(let description of eventNamesDescription){
                    if (description.eventName == event.eventName){
                        added_event = true
                        break
                    }
                }
                if (!added_event){
                    eventNamesDescription.push({eventName: event.eventName})
                    chosen_color = event.color
                    _events.push({'dates':[],
                                  'dot':chosen_color,
                                  'eventName': event.eventName})
                }
                for (let _event of _events){
                    if (_event.eventName == event.eventName){
                        for (let date_between of getDatesBetween(event.date, event.date_end)){
                            _event.dates.push(date_between)
                        }
                        // _event.dates.push(event.date)
                        // _event.dates.push(new Date())
                    }
                }
            }
            console.log('_events in calendarEvents')
            console.log(_events)
            return _events
        },
        selectedDateEvents(){
            if(!(this.selectedDate instanceof Date))
                return []
            let _events = this.events.filter((event) => event.date.getDate() == this.selectedDate.getDate() &&
                                                        event.date.getMonth() == this.selectedDate.getMonth() &&
                                                        event.date.getFullYear() == this.selectedDate.getFullYear())
            for (let _event of _events)
                _event.color = this.eventColors[_event.eventName] 
            return _events
        },
        nearestEvent() {
            let nearestDay = ''
            if (this.selectedDateEvents.length > 0)
                return nearestDay
            if(!(this.selectedDate instanceof Date))
                return nearestDay
            let eventDifference = ''
            let nearestDayDifference = ''
            for (let event of this.events){
                if (nearestDay == ''){
                    nearestDay = event.date
                    continue
                }
                eventDifference = Math.abs(event.date.getTime() - this.selectedDate.getTime()) 
                nearestDayDifference = Math.abs(nearestDay.getTime() - this.selectedDate.getTime())
                if (eventDifference < nearestDayDifference) {
                    nearestDay = event.date
                }
            }
            return nearestDay
        }
    },
    mounted() {
        let movePage = {
            month: this.selectedDate.getMonth() + 1,
            year: this.selectedDate.getFullYear()
        }
        this.$refs.calendar.move(movePage)
        this.$nextTick(() => {
        let monday_label = document.querySelector('.vc-weekday-2');
        monday_label.textContent = 'Пн'
        let tuesday_label = document.querySelector('.vc-weekday-3');
        tuesday_label.textContent = 'Вт'
        let wednesday_label = document.querySelector('.vc-weekday-4');
        wednesday_label.textContent = 'Ср'
        let thursday_label = document.querySelector('.vc-weekday-5');
        thursday_label.textContent = 'Чт'
        let friday_label = document.querySelector('.vc-weekday-6');
        friday_label.textContent = 'Пт'
        let saturday_label = document.querySelector('.vc-weekday-7');
        saturday_label.textContent = 'Сб'
        let sunday_label = document.querySelector('.vc-weekday-1');
        sunday_label.textContent = 'Вс'
        let month_name = document.querySelector('.vc-title').children[0];
        if (month_name.textContent.length > 0){
            month_name.textContent = month_name.textContent[0].toUpperCase() + month_name.textContent.slice(1)
        }
        let prevMonthBtn = document.querySelector('.vc-arrow.vc-prev.vc-focus')
        let oldPrevSvg = prevMonthBtn.querySelector('.vc-base-icon')
        prevMonthBtn.removeChild(oldPrevSvg)
        let newPrevSvg = document.createElementNS("http://www.w3.org/2000/svg","svg")
        newPrevSvg.setAttribute("width","8")
        newPrevSvg.setAttribute("height","12")
        newPrevSvg.setAttribute("viewBox","0 0 8 12")
        newPrevSvg.setAttribute("fill","none")
        newPrevSvg.setAttribute("xmlns","http://www.w3.org/2000/svg")
        newPrevSvg.setAttribute("xmlns","http://www.w3.org/2000/svg")
        prevMonthBtn.appendChild(newPrevSvg)
        let newPrevPath = document.createElementNS("http://www.w3.org/2000/svg","path")
        newPrevPath.setAttribute("d","M7.03112 1.91996L5.77779 0.666626L0.444458 5.99996L5.77779 11.3333L7.03112 10.08L2.96001 5.99996L7.03112 1.91996Z")
        newPrevPath.setAttribute("fill","#0075AA")
        newPrevSvg.appendChild(newPrevPath)
        let nextMonthBtn = document.querySelector('.vc-arrow.vc-next.vc-focus')
        let oldNextSvg = nextMonthBtn.querySelector('.vc-base-icon')
        nextMonthBtn.removeChild(oldNextSvg)
        let newNextSvg = document.createElementNS("http://www.w3.org/2000/svg","svg")
        newNextSvg.setAttribute("width","8")
        newNextSvg.setAttribute("height","12")
        newNextSvg.setAttribute("viewBox","0 0 8 12")
        newNextSvg.setAttribute("fill","none")
        newNextSvg.setAttribute("xmlns","http://www.w3.org/2000/svg")
        newNextSvg.setAttribute("xmlns","http://www.w3.org/2000/svg")
        nextMonthBtn.appendChild(newNextSvg)
        let newNextPath = document.createElementNS("http://www.w3.org/2000/svg","path")
        newNextPath.setAttribute("d","M2.22257 0.666504L0.969238 1.91984L5.04035 5.99984L0.969238 10.0798L2.22257 11.3332L7.5559 5.99984L2.22257 0.666504Z")
        newNextPath.setAttribute("fill","#0075AA")
        newNextSvg.appendChild(newNextPath)
      })
    },
    methods: {
        transitionStart(){
            let observer = new MutationObserver(mutationRecords => {
                for (let record of mutationRecords){
                    for (let node of record.addedNodes){
                        if (node.className == 'vc-pane-layout vc-slide-left-enter-from vc-slide-left-enter-active' || 
                            node.className == 'vc-pane-layout vc-slide-right-enter-from vc-slide-right-enter-active'){
                            let monday_label = node.querySelector('.vc-weekday-2')
                            monday_label.textContent = 'Пн'
                            let tuesday_label = node.querySelector('.vc-weekday-3');
                            tuesday_label.textContent = 'Вт'
                            let wednesday_label = node.querySelector('.vc-weekday-4');
                            wednesday_label.textContent = 'Ср'
                            let thursday_label = node.querySelector('.vc-weekday-5');
                            thursday_label.textContent = 'Чт'
                            let friday_label = node.querySelector('.vc-weekday-6');
                            friday_label.textContent = 'Пт'
                            let saturday_label = node.querySelector('.vc-weekday-7');
                            saturday_label.textContent = 'Сб'
                            let sunday_label = node.querySelector('.vc-weekday-1');
                            sunday_label.textContent = 'Вс'
                            let month_name = node.querySelector('.vc-title').children[0];
                            if (month_name.textContent.length > 0){
                                month_name.textContent = month_name.textContent[0].toUpperCase() + month_name.textContent.slice(1)
                            }
                            observer.disconnect()
                        }
                    }
                }
            });
            let node = document.querySelector('.'+this.parentClass)
            observer.observe(node, {
                childList: true,
                subtree: true,
                characterDataOldValue: true
            })
        },
        dayClick(day){
            this.$emit('dayClick',new Date(day.id))
        }
    },
    watch:{
        selectedDate(newDate){
            let movePage = {
                month: newDate.getMonth() + 1,
                year: newDate.getFullYear()
            }
            this.$refs.calendar.move(movePage)
        }
    }
}

</script>